<template>
  <div class="state-icons-wrap">
    <n-icon v-for="icon in icons" :key="icon.mod" v-bind="icon" />
  </div>
</template>

<script>
import NIcon from '@/components/musicbox/icon/mod-state.vue';
import { getModOptions } from '../utils';

export default {
  components: {
    NIcon
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    deviceType() {
      return this.data.deviceType;
    },
    options() {
      return getModOptions(this.deviceType);
    },
    icons() {
      const { modState: mods = {} } = this.data;
      const res = [];
      let temp = null;
      this.options.forEach(e => {
        temp = mods[e.mod];
        res.push({
          ...e,
          runstate: (temp && temp.runstate) || 0,
          state: (temp && temp.state) || 0
        });
      });
      return res;
    }
  }
};
</script>

<style lang="scss">
.state-icons-wrap {
  display: flex;
  justify-content: space-around;
  .n-icon-wrap {
    cursor: auto;
  }
}
</style>
